import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSFormDate } from 'components';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../../css/ArretTravail.module.scss';

const WorkStoppageDetails: React.FC = () => {
    const { getValues } = useFormContext();

    return (
        <>
            <Box className={classNames(styles.title, 'mb-4')}>Détail sur l’arrêt :</Box>
            <SGSForm.Row>
                <SGSForm.Col md={6}>
                    <SGSFormDate inputVariant="outlined" name="workStoppage.infos.start" label="workStop.fields.workStoppage.infos.start" maxDate={new Date()} />
                </SGSForm.Col>
                <SGSForm.Col md={6}>
                    <SGSFormDate inputVariant="outlined" name="workStoppage.infos.end" label="workStop.fields.workStoppage.infos.end" minDate={getValues('workStoppage.infos.start')} />
                </SGSForm.Col>
            </SGSForm.Row>
            <SGSForm.Row>
                <SGSForm.Col md={6}>
                    <SGSFormDate
                        inputVariant="outlined"
                        name="workStoppage.infos.lastDayWorked"
                        label="workStop.fields.workStoppage.infos.lastDayWorked"
                        maxDate={getValues('workStoppage.infos.start') ?? new Date()}
                    />
                </SGSForm.Col>
            </SGSForm.Row>
        </>
    );
};

export default WorkStoppageDetails;
